<template>
    <div>
        <a-card title="执行器管理">
            <a-button slot="extra" @click="add">新增</a-button>
            <a-form layout="inline" @submit="getData" :form="form" >

                <a-form-item label="AppName">
                    <a-input v-model="searchP.appname" placeholder="AppName"></a-input>
                </a-form-item>

                <a-form-item label="名称">
                    <a-input v-model="searchP.title" placeholder="请输入名称"></a-input>
                </a-form-item>
                
                <a-form-item>
                    <a-button type="primary" htmlType="submit" :key="this.loading.key">筛选</a-button>
                </a-form-item>
                <a-form-item>
                    <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
                    </a-button>
                </a-form-item>
            </a-form>

            <!-- 系统列表 -->
            <a-table :columns="columns" :data-source="list" :scroll="{ x: 800}" :pagination="false" :loading="tLoading" rowKey="id" style="margin-top:20px;" >

                <template slot="registryLists" slot-scope="text">
                    <a-button v-if="text" type="link" @click="handleRemarkModal(text)">查看 ({{ text.length }})</a-button>
                    <span v-else>无</span>
                </template>
                 <template slot="operation" slot-scope="text,item">
                    <a-button type="link" class="but_type"  @click="()=> edit(item)">编辑
                        </a-button>
                        <a-popconfirm @confirm="() => remove(item)">
                            <template slot="title">
                                <p>{{ '确认将【' + item.title + '】删除？' }}</p>
                            </template>
                            <a-button type="link" class="but_type">删除</a-button>
                        </a-popconfirm>
                </template>
            </a-table>
            
            <a-pagination class="my_pagenation" v-model="searchP.page" :total="searchP.total" @change="handlePageChange" show-less-items show-quick-jumper />

            <a-modal v-model="visible" :title="modalTitle" :footer="null">
                <p v-for="item in currentList" :key="item">{{item}}</p>
            </a-modal>

            <editor ref="editorID" @onModalHide="getData"></editor>
        </a-card>
    </div>
</template>

<script>
import editor from "./item"
const colums = [
    {
        title: "AppName",
        width: 200,
        align: "center",
        dataIndex: 'appname',
    },
    {
        title: '名称',
        dataIndex: 'title',
        align: 'center',
        width:200,
    },
    {
        title: '注册方式',
        dataIndex: 'addressType',
        align: 'center',
        width:100,
        customRender: (text) => {
            if(text == 0){
                return '自动注册'
            }
            else{
                return '手动录入'
            }
        },
    },
    {
        title: 'OnLine机器地址',
        dataIndex: 'registryList',
        align: 'center',
        width:200,
        scopedSlots: { customRender: 'registryLists' },
    },

    {
        title: '操作',
        dataIndex: 'operation',
        width:200,
        align: 'center',
        scopedSlots: { customRender: 'operation' },
    }
                
];

export default {
    components: {
        editor
    },
    mounted() {
        this.getData()
    },
    data() {
        return {
            visible:false,
            modalTitle:'执行器地址',
            currentList:[],
            form: this.$form.createForm(this),
            tLoading:false,
            searchP:{
                appname:'',
                title:'',
                length:10,
                start:0,
                page:1,
                total:0
            },
            list:[],
            columns:colums,
            
        };
    },
    methods: {
        handleCancel(){
            this.editorModalVisible = false;
        },
        // 分页事件
        handlePageChange(c){
            this.searchP.page = c;
            this.getData()
        },
        handleRemarkModal(text){
            this.currentList = text ? text : [];
            this.visible = true;
        },
        //筛选重置
        handleSearchReset() {
            this.searchP = {
                appname:'',
                title:'',
                length:10,
                start:0,
                page:1,
                total:0
            }
            this.getData();
        },
        //获取列表
        getData(){
            let that = this;
            that.tLoading = true;
            that.searchP.start = (that.searchP.page - 1) * that.searchP.length;
            that.$store.dispatch({
                type: 'jobcenter/jobgrouplist',
                params: that.searchP,
            }).then((res) => {
                if(res.status == 200){
                    let result = res.data;
                    that.list = result.data;
                    that.searchP.total = result.recordsTotal;
                }
                that.tLoading = false;
            });
        },

        edit(item){
            this.$refs.editorID.init(item)
        },
        add(){
            this.$refs.editorID.init({ id:'' })
        },
        remove(item){
            let that = this;
            that.$store.dispatch({
                type: 'jobcenter/removeJobGroup',
                params: {
                    id:item.id,
                    urlparams:false,
                }
            }).then((res) => {
                if (res.data.code == 200) {
                    that.message.success('操作成功')
                    that.getData()
                }
                else{
                    that.message.error(res.data.msg || '操作失败')
                }
            });
        }

    },

    
};

</script>

<style lang="less" scoped>

</style>
